import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { InventoryAdjustment } from 'commons/types';
import { bulkRetryUpdateInventoryAdjustment } from 'redux-stores/actions';

export const RowMenuItemConfig = [
  {
    name: 'Retry',
    onClick: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      documentNumbers: string[],
      location?: number,
    ): void => {
      dispatch(
        bulkRetryUpdateInventoryAdjustment({ documentNumbers, location }),
      );
    },
    disabled: (selected: InventoryAdjustment[]): boolean => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].status === 'update-failed') return false;
      }
      return true;
    },
  },
];
